import { apiFetch } from "../../api/client";
import type { AdminTelemetryBreakdown, AdminTelemetryDailySeries, AdminTelemetryGroupBy, CampaignTelemetry } from "../../api/types";

/** `GET admin/campaigns/{id}/telemetry` (role Consulta). Graceful-degradation envelope (design.md). */
export function getCampaignTelemetry(campaignId: string): Promise<CampaignTelemetry> {
  return apiFetch<CampaignTelemetry>(`/panel/campaigns/${campaignId}/telemetry`);
}

/**
 * `GET panel/telemetry/daily?days=` (role Consulta, issue #355). `days`
 * omitted entirely when not passed — the backend's own default (30) and
 * range validation (`AdminTelemetryDailyRange`, 1–365) are the single
 * source of truth; this never duplicates that clamping client-side.
 */
export function getTelemetryDaily(days?: number): Promise<AdminTelemetryDailySeries> {
  const query = days !== undefined ? `?days=${days}` : "";
  return apiFetch<AdminTelemetryDailySeries>(`/panel/telemetry/daily${query}`);
}

/** `GET panel/telemetry/breakdown?groupBy=template|show` (role Consulta, issue #356). `groupBy` is required by the backend — never omitted here. */
export function getTelemetryBreakdown(groupBy: AdminTelemetryGroupBy): Promise<AdminTelemetryBreakdown> {
  return apiFetch<AdminTelemetryBreakdown>(`/panel/telemetry/breakdown?groupBy=${groupBy}`);
}
